import { IAppContextActions } from 'contexts/App/types'
import { json } from 'services/RequestService'
import { IBaseResponse } from 'services/RequestService/Response'

export type BotRuleTriggerMessage = {
  message: string
  time: number
}

export type BotRuleTriggerEvent = {
  event: string
  time: number
}

export type BotRuleTrigger = BotRuleTriggerMessage | BotRuleTriggerEvent

export interface BotRule {
  name: string
  bot: string
  rules: BotRuleTrigger[]
  active: boolean
  updated_at: string
  created_at: string
}

interface ListBotRulesResponse {
  items: BotRule[]
}

export const listBotRules = async (
  botName: string,
  dispatch: React.Dispatch<IAppContextActions>,
): Promise<IBaseResponse<ListBotRulesResponse>> => {
  const token = localStorage.getItem('@studio:user_access_token')
  const action = `/bots/${botName}/rules`
  return json<ListBotRulesResponse>(
    'GET',
    action,
    dispatch,
    undefined,
    undefined,
    {
      baseUrl: process.env.REACT_APP_FOLLOW_UP_DISPATCHER_URL,
      customRequestInit: {
        headers: {
          'Content-Type': 'application/json',
          'x-fintalk-origin': 'studio/backoffice',
          Authorization: `Bearer ${token}`,
        },
      },
    },
  )
}
